"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AUTH_PROPERTY_COLUMN_TYPE = exports.AUTH_PROPERTY_TYPE = void 0;
exports.AUTH_PROPERTY_TYPE = {
    authentication: 'authentication',
};
exports.AUTH_PROPERTY_COLUMN_TYPE = {
    synergyId: 'synergyId',
    date: 'date',
    mailAddress: 'mailAddress',
    monthDay: 'monthDay',
    number: 'number',
    passwordHash: 'passwordHash',
    text: 'text',
};
